import React from "react";
import { connect } from "react-redux";
import { StateType } from "../../../../../State/Store";
import FormBuilder, {
  FormState,
} from "../../../../../Tools/FormBuilder/FormBuilder";
import HttpClient from "../../../../../State/HttpClient";
import Toast from "../../../../../Layout/Common/Toast";
import Records, { RecordObject } from "../../../../../State/Records";
import { pushRoute, RouterState } from "../../../../../State/Router";
import HiddenField from "../../../../FormFields/HiddenField";
import ItemCwFormLayout from "../ItemForms/ItemCwFormLayout";
import { trans } from "../../../../../Tools/LocaleHandler";
import Label from "../../../../Util/Label";
import Field from "../../../../../Tools/FormBuilder/Field";
import DateTimeField from "../../../../FormFields/DateTimeField";
import OptionsField from "../../../../FormFields/OptionsField";
import { getItemListSignature } from "../../../../Layout/BodyOpenedWeb";
import { DisplayArea } from "../../../../Root";
import InputField from "../../../../FormFields/InputField";
import AnswerField from "../../../../FormFields/AnswerField";
import WYSIWYGTextField from "../../../../FormFields/WYSIWYGTextField";
import ButtonsField from "../../../../FormFields/ButtonsField";
import serverValidation from "./serverValidation";

type RouteParams = { displayArea: DisplayArea };
export default connect((state: StateType, props: { rstate: RouterState }) => {
  const params = props.rstate.params;
  return {
    authObject: state.app.authObject,
    params,
  };
})((props: { authObject: RecordObject; params: RouteParams }) => {
  const in4Days = new Date(new Date().setDate(new Date().getDate() + 4));
  return (
    <FormBuilder
      key={"form-itemPoll"}
      action={(blueprint, done) => {
        HttpClient.action(
          "create",
          "Item",
          { blueprint },
          false,
          serverValidation
        )
          .then((item) => {
            Toast.show({ type: "info", text: trans(Label.UI__SUCCESS) });
            Records.addToList(
              getItemListSignature(
                blueprint.fields.type,
                null,
                blueprint.fields.displayArea
              ),
              "Item",
              item
            );
            if (blueprint.fields.exclusive) {
              Records.addToList(
                getItemListSignature(
                  "adminExclusive",
                  null,
                  "tariffArea",
                  true
                ),
                "Item",
                item
              );
            }
            pushRoute(`/Admin/ItemLanding/${item.uuid}`);
          })
          .catch((ex) => {
            console.warn(ex);
          })
          .finally(() => done());
      }}
      fields={{
        // step 0
        displayArea: new HiddenField(
          "form-item-displayArea-id",
          Field.FLAG_REQUIRED,
          props.params.displayArea
        ),
        type: new HiddenField("form-item-type-id", Field.FLAG_REQUIRED, "poll"),
        association: new HiddenField(
          "form-item-association-id",
          Field.FLAG_OPTIONAL,
          props.authObject.record.associationAdmin
            ? props.authObject.record.associationAdmin.uuid
            : null
        ),
        title: new InputField("form-item-title-id", Field.FLAG_REQUIRED, null, {
          label: trans(Label.FORM__TITLE),
          validations: ["maxChar200"],
        }),
        desc: new InputField("form-item-desc-id", Field.FLAG_REQUIRED, null, {
          label: trans(Label.FORM__DESC),
          validations: ["maxChar200"],
        }),
        text: new WYSIWYGTextField(
          "form-item-text-id",
          Field.FLAG_OPTIONAL,
          null,
          { label: trans(Label.FORM__TEXT) }
        ),
        expiry: new DateTimeField(
          "form-item-expiry-id",
          Field.FLAG_OPTIONAL,
          in4Days,
          {
            label: trans(Label.FORM__EXPIRY),
            meta: "skipNow",
          }
        ),
        // step 1
        publishState: new ButtonsField(
          "form-item-publishState-id",
          Field.FLAG_REQUIRED,
          null,
          {
            label: trans(Label.ADMIN__CONTENT_WIZARD_ITEM_TYPE),
            options: [
              {
                value: "published",
                label: trans(Label.ITEM__PUBLISHED),
                onSelect: (form) => {
                  form.setFieldValue("publishState", "published");
                  form.setFieldRequired("publishDate", true);
                },
                selected: true,
              },
              {
                value: "draft",
                label: trans(Label.ITEM__DRAFT),
                onSelect: (form) => {
                  form.setFieldValue("publishState", "draft");
                  form.setFieldValue("pushNotification", false);
                  form.setFieldRequired("publishDate", false);
                  form.setFieldRequired("pushNotification", false);
                  form.setFieldRequired("pushTitle", false);
                  form.setFieldRequired("pushText", false);
                },
              },
            ],
          },
          false,
          {
            padding: "8px 30px 7px",
            borderRadius: "4px",
            textTransform: "uppercase",
            marginLeft: "0px",
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          }
        ),
        exclusive: new OptionsField(
          "form-item-exclusive-id",
          Field.FLAG_OPTIONAL
        ),
        publishDate: new DateTimeField(
          "form-item-publishDate-id",
          Field.FLAG_REQUIRED,
          new Date(),
          { label: trans(Label.FORM__PUBLISH_DATE) }
        ),
        pushNotification: new OptionsField(
          "form-item-pushNotification-id",
          Field.FLAG_OPTIONAL,
          true,
          null,
          (value: any, form: FormState) => {
            form.setFieldRequired && form.setFieldRequired("pushTitle", value);
            form.setFieldRequired && form.setFieldRequired("pushText", value);
          }
        ),
        pushTitle: new InputField(
          "form-item-pnTitle-id",
          Field.FLAG_REQUIRED,
          null,
          {
            label: trans(Label.FORM__TITLE),
            validations: ["maxChar60"],
          }
        ),
        pushText: new InputField(
          "form-item-pnText-id",
          Field.FLAG_REQUIRED,
          null,
          {
            label: trans(Label.FORM__TEXT),
            validations: ["maxChar120"],
          }
        ),
      }}
      metas={{
        answer1: new AnswerField(
          "form-item-answer1-id",
          Field.FLAG_REQUIRED,
          null,
          { label: trans(Label.FORM__ANSWER), validations: ["maxChar200"] }
        ),
        answer2: new AnswerField(
          "form-item-answer2-id",
          Field.FLAG_REQUIRED,
          null,
          { label: trans(Label.FORM__ANSWER), validations: ["maxChar200"] }
        ),
        answer3: new AnswerField(
          "form-item-answer3-id",
          Field.FLAG_OPTIONAL,
          null,
          { label: trans(Label.FORM__ANSWER), validations: ["maxChar200"] }
        ),
      }}
      layout={ItemCwFormLayout}
      steps={[
        [
          "form-item-text-id",
          "form-item-title-id",
          "form-item-desc-id",
          "form-item-expiry-id",
          "form-item-answer1-id",
          "form-item-answer2-id",
          "form-item-answer3-id",
        ],
        [
          "form-item-publishDate-id",
          "form-item-pushNotification-id",
          "form-item-pnTitle-id",
          "form-item-pnText-id",
        ],
      ]}
      data={{ contentType: trans(Label.ITEM__TYPE_POLL) }}
    />
  );
});
